define.alias("ember-math-helpers/helpers/atan", "media/helpers/atan");